import { createStyles, makeStyles, Theme } from '@material-ui/core';

const useStyles = makeStyles((theme: Theme) => createStyles({
  root: {
    width: '100%',
    height: 'auto',
    // overflow: 'auto',
  },
  // ロゴ
  logoContainer: {
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    gap: '16px',
    padding: '24px 16px 0',
  },
  logoImage: {
    maxHeight: '80px',
    maxWidth: '260px',
    objectFit: 'contain' as const,
    [theme.breakpoints.down('sm')]: {
      maxHeight: '48px',
      maxWidth: '160px',
    },
  },
  // ステップヘッダー
  stepsHeader: {
    textAlign: 'center',
    padding: '32px 16px 8px',
  },
  stepsHeaderSub: {
    fontSize: '15px',
    color: '#666',
    letterSpacing: '0.5px',
    marginBottom: '6px',
  },
  stepsHeaderMain: {
    fontSize: '22px',
    fontWeight: 700,
    color: '#1a1a1a',
    letterSpacing: '0.5px',
    [theme.breakpoints.down('sm')]: {
      fontSize: '18px',
    },
  },
  stepsFlow: {
    display: 'flex',
    alignItems: 'center',
    margin: '24px 0 48px',
    [theme.breakpoints.down('sm')]: {
      flexDirection: 'column',
      margin: '16px 0 32px',
      gap: '0px',
    },
  },
  stepFirst: {
    flex: 1,
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    padding: '22px 16px',
    color: '#fff',
    fontWeight: 700,
    fontSize: '15px',
    letterSpacing: '0.8px',
    textAlign: 'center',
    background: 'linear-gradient(135deg, #C0392B 0%, #E74C3C 100%)',
    borderRadius: '4px',
    boxShadow: '0 2px 8px rgba(192, 57, 43, 0.35)',
    [theme.breakpoints.down('sm')]: {
      width: '100%',
      padding: '14px 16px',
      borderRadius: '6px',
    },
  },
  stepArrow: {
    flexShrink: 0,
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    color: '#BBBBBB',
    fontSize: '20px',
    padding: '0 6px',
    userSelect: 'none',
    '&::after': {
      content: '"▶"',
    },
    [theme.breakpoints.down('sm')]: {
      width: '100%',
      padding: '4px 0',
      fontSize: '14px',
      '&::after': {
        content: '"▼"',
      },
    },
  },
  stepMiddle: {
    flex: 1,
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    padding: '22px 16px',
    color: '#fff',
    fontWeight: 700,
    fontSize: '15px',
    letterSpacing: '0.8px',
    textAlign: 'center',
    background: 'linear-gradient(135deg, #E74C3C 0%, #F1736A 100%)',
    borderRadius: '4px',
    boxShadow: '0 2px 8px rgba(231, 76, 60, 0.25)',
    [theme.breakpoints.down('sm')]: {
      width: '100%',
      padding: '14px 16px',
      borderRadius: '6px',
    },
  },
  stepLast: {
    flex: 1,
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    padding: '22px 16px',
    color: '#fff',
    fontWeight: 700,
    fontSize: '15px',
    letterSpacing: '0.8px',
    textAlign: 'center',
    background: 'linear-gradient(135deg, #F1736A 0%, #F8A09A 100%)',
    borderRadius: '4px',
    boxShadow: '0 2px 8px rgba(241, 115, 106, 0.2)',
    [theme.breakpoints.down('sm')]: {
      width: '100%',
      padding: '14px 16px',
      borderRadius: '6px',
    },
  },

  // desired service section
  desireServiceSection: {
    marginTop: '26px',
    marginRight: '80px',
    marginLeft: '80px',
    [theme.breakpoints.down('sm')]: {
      marginTop: '22px',
      marginRight: '10px',
      marginLeft: '10px',
    },
  },
  serviceItem: {
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center',
    marginBottom: '30px',
    [theme.breakpoints.down('sm')]: {
      flexDirection: 'column',
      justifyContent: 'flex-start',
      alignItems: 'flex-start',
      marginBottom: '28px',
    },
  },
  serviceLabel: {
    display: 'flex',
    justifyContent: 'flex-start',
    alignItems: 'center',
    minWidth: '260px',
    backgroundColor: '#EBEBEB',
    paddingLeft: '8px',
    marginRight: '25px',
    [theme.breakpoints.down('sm')]: {
      display: 'block',
      width: '100%',
      padding: '8px',
      marginBottom: '18px',
      marginRight: '0px',
    },

    '& p': {
      fontFamily: 'Noto Sans JP',
      fontSize: '18px',
      fontWeight: 600,
      lineHeight: '26px',
      letterSpacing: '0.8px',
      color: '#1a1a1a',
      [theme.breakpoints.down('sm')]: {
        fontSize: '15px',
        lineHeight: '23px',
        marginTop: 0,
        marginBottom: 0,
      },
    },
  },
  serviceLabelStretch: {
    alignSelf: 'stretch',
    [theme.breakpoints.down('sm')]: {
      alignSelf: 'auto',
    },
  },
  buttonContainer: {
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
  },
}));

export default useStyles;
